var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUnblock = function SvgIconUnblock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.95,
    height: 15.95,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.3,
    d: "M7.65.65a7 7 0 1 1 0 14 7 7 0 0 1 0-14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path",
    fillRule: "evenodd",
    d: "M8.999 6.658h-.103V5.38A1.74 1.74 0 0 0 7.15 3.65a1.74 1.74 0 0 0-1.746 1.73v.098c0 .261.213.472.476.472a.474.474 0 0 0 .476-.472V5.38c0-.433.356-.786.794-.786.438 0 .794.353.794.786v1.278H5.301a.648.648 0 0 0-.651.645v2.702c0 .356.291.645.651.645h3.698c.36 0 .651-.289.651-.645V7.303a.648.648 0 0 0-.651-.645zM7.507 8.707v.468c0 .196-.16.354-.357.354a.355.355 0 0 1-.357-.354v-.468a.607.607 0 0 1 .357-1.105.607.607 0 1 1 .357 1.105z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUnblock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-unblock.2ee28850.svg";
export { ForwardRef as ReactComponent };